import { render, staticRenderFns } from "./CustomFieldManage.vue?vue&type=template&id=2bccbe42&"
import script from "./CustomFieldManage.vue?vue&type=script&lang=js&"
export * from "./CustomFieldManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports